<ng-container *ngIf="babState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ data.id ? ('app.dialog.join-cost-center-cost-center.edit.header' | translate) :('app.dialog.join-cost-center-cost-center.add.header' | translate) }}
    </h1>
    <div mat-dialog-content>
        <mat-generic-input
            [fields]="data.id? state.dialogEditFields: state.dialogAddFields"
            [initialValue]="data"
            [(inputFormGroup)]="formGroup">
        </mat-generic-input>
    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
        <button [disabled]="data.id ? false : !(dialogFieldsValid | async)" mat-flat-button color="primary" (click)="save()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
